import { MixpanelEvents } from '@/constants/mixpanelEvents';
import { mixpanelService } from '@/services/mixpanelService';
import type { ICheckoutContext } from '@/types/context';
import { getMixpanelProperties } from '@/utils/mixpanelProperties';

const CHECKOUT_OPENED_AT_KEY = 'checkout_opened_at';

const getCheckoutLoadTime = (): number | undefined => {
  const checkoutOpenedAt = Number(sessionStorage.getItem(CHECKOUT_OPENED_AT_KEY));

  if (!Number.isFinite(checkoutOpenedAt)) {
    return undefined;
  }

  return Math.max(0, Math.round(performance.now() - checkoutOpenedAt));
};

export const trackCheckoutPresented = (session_id: string, context?: ICheckoutContext): void => {
  mixpanelService.track(
    MixpanelEvents.CHECKOUT_PRESENTED,
    getMixpanelProperties(context, { session_id, load_time: getCheckoutLoadTime() }) as Record<string, unknown>
  );
};

export const trackCheckoutOpened = (session_id: string, context?: ICheckoutContext): void => {
  sessionStorage.setItem(CHECKOUT_OPENED_AT_KEY, performance.now().toString());
  mixpanelService.track(
    MixpanelEvents.CHECKOUT_OPENED,
    getMixpanelProperties(context, { session_id }) as Record<string, unknown>
  );
};

export const trackPayButtonClicked = (context: ICheckoutContext, paymentMethodName?: string): void => {
  const properties = getMixpanelProperties(context, {
    payment_method: paymentMethodName,
    session_id: context.sessionId,
    purchase_id: context?.orderId,
  }) as Record<string, unknown>;

  mixpanelService.track(MixpanelEvents.PAY_BUTTON_CLICKED, {
    ...properties,
  });
};
